export default "__VITE_ASSET__BgvizfK$__"